// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"V7Q8W","content":"_1J7Ps"};